import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import {
  CTA,
  CustomInput,
  CustomSelect,
  Icon,
  Modal,
  NoResult,
  RadioButton,
  Text,
} from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import theme from '../../../theme';
import Pagination from '../../Pagination';
import { STATS_USER_LIST } from '../../../../app/redux/actions/statistics';
import SortBy from '../../SortBy';
import { FiltersWrapper, Legend, SortingWrapper, UserCard } from './style';
import routes from '../../../../routes';
import { timestampToDate } from '../../../../utils/common';
import {
  getFilterLabel,
  getFilterOptions,
  getSortingOptions,
} from '../../../../utils/labels';
import Inline from '../../Inline';
import TimeIntervalFilter from '../../TimeIntervalFilter';

export const ModalUserListId = 'ModalUserList';

const ModalUserList = ({
  mediaIsPhone,
  list,
  filters,
  pager,
  getUsers,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  const navigate = useNavigate();
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleGetUsers = ({
    page,
    filters_only = undefined,
    currentFilters = {},
  }) => {
    const parsedFilters = {
      ...currentFilters,
      filters_only,
      page,
    };

    getUsers(parsedFilters);
  };

  useEffect(() => {
    handleGetUsers({ filters_only: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickSearch = () => {
    if (selectedFilters?.search_text) {
      handleGetUsers({
        currentFilters: { ...selectedFilters },
      });
    }
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
    if (key === 'ffoo' || key === 'regions') {
      handleGetUsers({ currentFilters: newFilters, filters_only: true });
    }
  };

  const loadMore = (page) => handleGetUsers(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  const isMandatory = (key) => {
    if (key === 'ffoo') return 'mandatory-select';
    //if (key === 'group_ids' && selectedFilters?.visibility) return 'mandatory-select';
    return '';
  };

  return (
    <Modal
      title="Lista utenti"
      modalId={ModalUserListId}
      scrollableAreaRef={scrollableAreaRef}
      mbTitle={16}
    >
      <Text type="b3" mb={32}>
        Sezione dedicata agli utenti che hanno visibilità sui percorsi formativi
        di cui sei tutor.
      </Text>
      <FiltersWrapper>
        <CustomInput
          size={426}
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) =>
            setSelectedFilters({ ...selectedFilters, search_text: v })
          }
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />
        {(Object.keys(filters) || []).map((key, i) => (
          <CustomSelect
            size="s"
            key={`filter-${i}`}
            wrapperId={`filter-${key}`}
            placeholder={getFilterLabel(key)}
            options={getFilterOptions(filters, key)}
            onChange={(value) => handleOnChange({ key, value })}
            isClearable
            className={isMandatory(key)}
          />
        ))}
        <TimeIntervalFilter
          callback={(start_date, end_date) => {
            setSelectedFilters({
              ...selectedFilters,
              start_date,
              end_date,
            });
          }}
        />
      </FiltersWrapper>
      <Inline columnGap="32px" alignItems="baseline" tag="fieldset">
        <Text type="b4" tag="legend">
          Seleziona utenti da visualizzare per:
        </Text>
        <Inline columnGap="24px">
          {/* //? "Iscrizioni" is ko */}
          <RadioButton
            label="Assegnazioni"
            name="filter"
            onChange={() =>
              setSelectedFilters({
                ...selectedFilters,
                visibility: 'assignments',
              })
            }
            checked={selectedFilters?.visibility === 'assignments'}
          />
          <RadioButton
            label="Fruizioni"
            name="filter"
            onChange={() =>
              setSelectedFilters({
                ...selectedFilters,
                visibility: 'fruitions',
              })
            }
            checked={selectedFilters?.visibility === 'fruitions'}
          />
          <RadioButton
            label="Completamenti"
            name="filter"
            onChange={() =>
              setSelectedFilters({
                ...selectedFilters,
                visibility: 'completions',
              })
            }
            checked={selectedFilters?.visibility === 'completions'}
          />
        </Inline>
        <CTA
          id="cta-search"
          btnText="Cerca"
          disabled={
            !selectedFilters?.ffoo
            //|| (selectedFilters?.visibility && !selectedFilters?.group_ids)
          }
          onClick={() => handleGetUsers({ currentFilters: selectedFilters })}
          bottomRight
        />
      </Inline>
      <SortingWrapper>
        <Inline columnGap="16px" alignItems="flex-start">
          <Text type="b3">{pager?.total_items || 0} utenti </Text>
          <Icon
            type="users-01"
            stroke={theme().colors.textPrimary}
            clickable={false}
            size={24}
          />
        </Inline>
        <SortBy
          options={getSortingOptions([
            'access_asc',
            'access_desc',
            'alphabetical_asc',
            'alphabetical_desc',
          ])}
          onChange={(v) => {
            const newFilters = { ...selectedFilters, sort_by: v?.value };
            setSelectedFilters(newFilters);
            if (newFilters?.ffoo) {
              handleGetUsers({ currentFilters: newFilters });
            }
          }}
        />
      </SortingWrapper>
      {list?.length > 0 && (
        <Legend>
          <Text type="statistics-heading">Nome e Cognome</Text>
          <Text type="statistics-heading">Matricola</Text>
          <Text type="statistics-heading">Forza dell'ordine</Text>
          <Text type="statistics-heading">Ruolo</Text>
          <Text type="statistics-heading">Regione</Text>
          <Text type="statistics-heading">Provincia</Text>
          <Text type="statistics-heading">Ultimo accesso</Text>
        </Legend>
      )}
      <ScrollableArea
        ref={scrollableAreaRef}
        preserveShadows
        className="auto-height"
      >
        {!list?.length > 0 && <NoResult />}
        {(list || []).map((user, i) => (
          <UserCard key={`user-${i}`}>
            <Text
              type="h3"
              onClick={() => {
                navigate(`${routes.userStatistics.path}/${user?.uid}`);
                modalClose();
              }}
            >
              {user?.first_name} {user?.last_name}
            </Text>
            <Text type="b4">{user?.matricola || '-'}</Text>
            <Text type="b4">{user?.ffoo || '-'}</Text>
            <Text type="b4">{user?.work_role || '-'}</Text>
            <Text type="b4">{user?.region || '-'}</Text>
            <Text type="b4">{user?.province || '-'}</Text>
            <Text type="b4">
              {timestampToDate(user?.last_access, 'DD/MM/YYYY - HH:mm')}
            </Text>
          </UserCard>
        ))}
      </ScrollableArea>
      <Footer pt={40} pb={48}>
        {pager?.number_of_pages > 1 ? (
          <Pagination
            pb={0}
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        ) : (
          <CTA type="secondary" onClick={modalClose} btnText="chiudi" />
        )}
      </Footer>
    </Modal>
  );
};

ModalUserList.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  list: PropTypes.array,
  filters: PropTypes.object,
  pager: PropTypes.object,
  // dispatch
  getUsers: PropTypes.func.isRequired,
  modalClose: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { list, filters, pager } = state.statistics.users;
      return { list, filters, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getUsers: (filters) =>
        dispatch({ type: STATS_USER_LIST._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalUserList);
